import { render } from "./ModalUpdateUser.vue?vue&type=template&id=6f041f0d"
import script from "./ModalUpdateUser.vue?vue&type=script&lang=js"
export * from "./ModalUpdateUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__